<template>
  <div v-loading="loading">
    <login-header v-bind="headerInfo" @listenToChildEvent="showMsgFromChild"></login-header>
    <div class="brand" :style="{ height: screenHeight + 'px' }">
      <div class="brand__title">填写品牌信息</div>
      <div class="brand__body">
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">
          <el-form-item label="品牌名称：" prop="brand">
            <el-input v-model.trim="form.brand" class="medium_width" placeholder="请填写品牌名称" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item class="is-required" label="门店数量：">
            <el-input-number v-model="form.store_amount" controls-position="right" :min="1" :max="100000"></el-input-number>
          </el-form-item>
          <el-form-item label="经营方式：" prop="operate_mode">
            <el-select popper-class="blueSelect" v-model="form.operate_mode">
              <el-option
                v-for="item in operationModel"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺地址：" prop="province_id">
            <el-cascader
              popper-class="blueCascader"
              class="selected medium_width"
              expand-trigger="hover"
              placeholder="请选择店铺地址"
              :options="region"
              v-model="selectedRegion"
              @change="handleChange">
            </el-cascader>
          </el-form-item>
          <el-form-item label="地图定位：" class="map-item" prop="lng">
            <el-button type="primary" plain @click="dialogVisible = true">选择经纬度</el-button>
            <el-input
              v-model="form.lng"
              disabled
              class="small_width ml10"
              placeholder="纬度"
            ></el-input>
            <el-input
              v-model="form.lat"
              disabled
              class="small_width ml10"
              placeholder="经度"
            ></el-input>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address">
            <el-input v-model="form.address" class="large_width" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="button_create" type="primary" @click="submit('form')">立即创建</el-button>
          </el-form-item>
        </el-form>
      </div>
      <login-footer :description="desc"></login-footer>
    </div>
     <!--获取经纬度组件-->
      <el-dialog
        class="mydialog"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="800px"
      >
        <getLatLong
          :address="form.street"
          :longitude="form.lng"
          :latitude="form.lat"
          :colorTheme="'blue'"
          @getLatLong="getLatLong"
        ></getLatLong>
      </el-dialog>

      <el-dialog class="successDialog" :visible.sync="dialogGetVisible" width="440px" center :before-close="handleClose">
        <span class="icon-yes"></span>
        <h5>提交成功</h5>
        <p>我们将在一个工作日内联系您</p>
      </el-dialog>
  </div>
</template>
<script>
import qs from 'qs'
import axios from 'axios'
import loginHeader from '../header'
import loginFooter from '../footer'
import GetLatLong from '../getLatLong/getLatLong'
export default {
  name: 'brandStore',
  components: {
    loginHeader,
    GetLatLong,
    loginFooter
  },
  data() {
    return {
      screenHeight: document.documentElement.clientHeight - 76,
      dialogGetVisible: false,
      loading: false,
      headerInfo: {
        type: '选择店铺',
        userDisplayFlag: true,
        userName: '',
        logo: ''
      },
      desc: '',
      form: {
        brand: '',
        store_amount: '',
        operate_mode: '',
        province_id: '',
        city_id: '',
        area_id: '',
        lng: '',
        lat: '',
        address: ''
      },
      selectedRegion: [], // 地区已选择值
      region: [], // 地区
      operationModel: [],
      dialogVisible: false,
      rules: {
        brand: [
          { required: true, message: '请填写品牌名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        operate_mode: [
          { required: true, message: '请选择经营方式', trigger: 'change' }
        ],
        province_id: [
          { required: true, message: '请选择店铺地址', trigger: 'change' }
        ],
        lng: [
          { required: true, message: '请选择经纬度', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请填写街道地址', trigger: 'change' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    document.title = localStorage.getItem('title')
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
    this.getOperation()
  },
  watch: {
    screenHeight (val) {
      if (!this.timer) {
        this.screenHeight = val
        this.timer = true
        setTimeout(() => {
          this.timer = false
        }, 400)
      }
    }
  },
  mounted() {
    this.headerInfo.userName = localStorage.getItem('mobile') || ''
    this.getRegion()
    this.get_bodyHeight()
  },
  methods: {
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          QM.apinew({
            url: '/crm/account/store/create-apply',
            method: 'post',
            data: this.form,
            success: res => {
              this.loading = false
              this.dialogGetVisible = true
            },
            error: err => {
              this.loading = false
              this.$message.error(err.message)
            }
          })
        } else {
          return false
        }
      })
    },
    handleChange(value) {
      this.form.province_id = value[0]
      this.form.city_id = value[1]
      this.form.area_id = value[2]
    },
    showMsgFromChild(data, loadingData) {
      this.loading = loadingData
      setTimeout(() => {
        this.loading = false
        this.headerInfo.userDisplayFlag = data
        localStorage.setItem('mobile', '')
        localStorage.setItem('mytoken', '')
        this.$router.push({ path: `/login.html` })
      }, 500)
    },
    getOperation() {
      QM.apinew({
        url: '/crm/account/store/operate-mode',
        method: 'get',
        success: res => {
          const { operateMode } = res.data
          let arr = []
          for (let key in operateMode) {
            let obj = {
              value: key,
              label: operateMode[key]
            }
            arr.push(obj)
          }
          this.operationModel = arr
        },
        error: () => {}
      })
    },
    getRegion() {
      axios
        .get('/static/js/region.json')
        .then(res => {
          this.region = res.data
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    setRegionDefalut() {
      let arr = []
      arr.push(this.form.province_id)
      arr.push(this.form.city_id)
      arr.push(this.form.area_id)
      return arr
    },
    getLatLong(val) {
      this.dialogVisible = false
      this.form.lng = val.lng.toString()
      this.form.lat = val.lat.toString()
      this.form.address = val.street
    },
    get_bodyHeight () {
      window.onresize = () => {
        return (() => {
          this.$nextTick(() => {
            window.screenHeight = document.documentElement.clientHeight - 76
            this.screenHeight = window.screenHeight
          })
        })()
      }
    },
    handleClose() {
      this.$router.push('/index.html')
    }
  }
}
</script>
<style>
.blueSelect .el-select-dropdown__item.selected, .blueCascader .el-cascader-menu__item.is-active {
  color: #3F9AFF;
}
.blueSelect .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  color: #3F9AFF;
}
</style>
<style lang="scss" scoped>
.brand{
  min-height: 860px;
  background: #3F9AFF url('https://img-shop.qmimg.cn/s1000184/images/2020/05/31/c307df4ac80f4bc4.png') bottom center no-repeat;
  background-size: 70% auto;
  padding-top: 52px;
  box-sizing: border-box;
  ::v-deep .el-input__inner:focus{
    border-color: rgba(63, 154, 255, 0.6)!important;
  }
  ::v-deep .el-select .el-input.is-focus .el-input__inner{
    border-color: rgba(63, 154, 255, 0.6)!important;
  }
  ::v-deep .el-input-number__increase:hover {
    color: #3F9AFF;
  }
  ::v-deep .el-input-number__decrease:hover {
    color: #3F9AFF;
  }
  ::v-deep .el-input-number:hover .el-input__inner {
    border-color: rgba(63, 154, 255, 0.6)!important;
  }
  &__title {
    font-size: 30px;
    line-height: 1.5;
    color: #fff;
    text-align: center;
    width: 100%;
    margin-bottom: 35px;
  }
  &__body {
    width: 980px;
    height: 620px;
    margin: 0 auto;
    padding: 60px;
    background: rgba(255,255,255,1);
    box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.08);
    border-radius: 20px;
    position: relative;
    display: flex;
    justify-content: space-between;
    .medium_width {
      width: 300px;
    }
    .large_width {
      width: 432px;
    }
    .small_width {
      width: 150px;
    }
    .el-form-item {
      margin-bottom: 25px;
    }
    .ml10 {
      margin-left: 10px;
    }
    .map-item {
      ::v-deep .el-form-item__content {
        display: flex;
      }
    }
  }
  .image-item {
    ::v-deep .el-form-item__label {
      padding: 30px 12px 0 0;
    }
    ::v-deep .el-form-item__content {
      display: flex;
    }
    .images-uploader {
      width: 110px;
    }
    .suggest {
      width: 350px;
      height: 110px;
      display: flex;
      align-items: flex-end;
      color: #999;
      font-size: 12px;
      text-align: left;
    }
  }
  .el-button--primary.is-plain{
    color: #3F9AFF;
    background-color: rgba(63, 154, 255, .1);
    border-color: rgba(63, 154, 255, .3);
  }
  .button_create {
    width: 300px;
    background-color: #3F9AFF;
    border-color: #3F9AFF;
  }
  .footer {
    padding: 25px 0 0;
  }
}
.successDialog {
  text-align: center;
  line-height: 1.5;
  border-radius: 10px;
  top: 50%;
  margin-top: -300px;
  .icon-yes {
    display: inline-block;
    width: 76px;
    height: 76px;
    background: url('https://img-shop.qmimg.cn/s1000184/images/2020/06/01/4f25cdc6b588bd9c.png') center no-repeat;
    background-size: 100% auto;
  }
  h5 {
    display: block;
    color: #333;
    font-size: 26px;
    font-weight: normal;
    margin: 30px 0 15px;
  }
  p {
    color: #333;
    font-size: 16px ;
    margin-top: 20px;
  }
  ::v-deep .el-dialog {
    border-radius: 10px;
  }
  ::v-deep .el-dialog--center .el-dialog__body {
    padding: 25px 25px 60px;
    text-align: inherit;
  }
  ::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
    color: #3F9AFF!important;
  }
}
.mydialog {
  ::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
    color: #3F9AFF!important;
  }
}
.blueCascader {
  ::v-deep .el-cascader-menu__item.is-active {
    color: #3F9AFF!important;
  }
}
</style>